import { AppResource } from './../../../app.resource';
import { Component, Inject, OnInit } from '@angular/core';
import { ConfirmContractVM } from 'src/app/shared/models/components/confirmcontractVm';
import { BaseComponent } from 'src/app/shared/components/base-component/base-component.component';
import { State } from 'src/app/core/state/core.state';
import * as fromContract from '../../../core/state/contract';
import { Contract } from 'src/app/core/models/form-state.model';
import { Store } from '@ngrx/store';
import { MatomoTracker } from 'ngx-matomo-client';
import { lastValueFrom, take } from 'rxjs';
import { addDownloadParam } from 'src/app/shared/utils/urlUtils';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'app-contract-confirmation',
  templateUrl: './contract-confirmation.component.html',
  styleUrls: ['./contract-confirmation.component.scss']
})
export class ContractConfirmationComponent extends BaseComponent implements OnInit {
  confirmContractVm!: ConfirmContractVM;
  contrat!: Contract;

  get brand() {
    return this.appConfig.getConfig('brand');
  }

  constructor(
    store: Store<State>,
    resources: AppResource,
    tracker: MatomoTracker,
    @Inject(AppConfig) private appConfig: AppConfig
  ) {
    super(store, resources, tracker);
  }

  override async ngOnInit() {
    super.ngOnInit();

    await this.loadStateData();

    this.initVm();
  }

  downloadDoc(uri: string) {
    window.open(uri, '_blank');
  }

  private async loadStateData() {
    this.contrat = await lastValueFrom(
      this.store.select(fromContract.selectContractState).pipe(take(1))
    );
  }

  private initVm() {
    if (this.contrat) {
      this.confirmContractVm = new ConfirmContractVM(
        this.contrat.NumeroContrat,
        addDownloadParam(this.contrat.RefDocumentCP),
        addDownloadParam(this.contrat.RefDocumentFIC),
        addDownloadParam(this.contrat.RefDocumentMandatSEPA),
        addDownloadParam(this.contrat.RefDocumentCG),
        addDownloadParam(this.contrat.RefDocumentAttestation),
        []
      );

      if (this.contrat.RefDocumentsSI.length > 0)
        this.contrat.RefDocumentsSI.forEach(doc => {
          this.confirmContractVm.attestationScolaire.push(addDownloadParam(doc));
        });
    } else {
      this.confirmContractVm = new ConfirmContractVM('', '', '', '', '', '', []);
    }
  }
}
